<template>
  <v-main>
    <v-wait :dialog="dialog" mensagem="Aguarde, carregando"></v-wait>
    <div v-show="erro">
      <br />
      <v-alert
        v-show="erro"
        :value="true"
        color="warning"
        type="warning"
      >Ocorreu um erro ao carregar os painéis!</v-alert>
    </div>
    <div v-show="dash.length==0">
      <br />
      <v-alert
        v-show="dash.length==0"
        :value="true"
        color="info"
        type="info"
      >Nenhum indicador cadastrado para empresa!</v-alert>
    </div>
    <v-container fluid fill-height>
      <v-row >
        <v-col v-for="item in dash" :key="item.id" >
          <v-card height="100%" style="position: relative" >
            <v-card-text height="100%">
              <iframe 
                :title="item.title"
                :width="item.width"
                :height="item.height" 
                :src="item.src" 
                :frameborder="item.frame_border" 
                :allowFullScreen="item.allow_full_screen"
                />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
/* eslint-disable */
import HomeModel from './HomeModel.js';
import VWait from "../../lib/components/screen/MdWait.vue";

export default {
  name: 'HelloWorld',
  components: {
    VWait
  },
  props: {
    msg: String
  },
  data() {
    return {
      model: new HomeModel(),
      dialog: false,
      erro: false,
      dash: [
         {"id": 0,
          "title": "Acompanhamentos DSLBR",
          "width": 600,
          "height": 373.5, 
          "allow_full_screen": true,
          "frame_border": 0,
          "src": 'https://app.powerbi.com/view?r=eyJrIjoiNzNkNjYwZjItYTBmMy00ODUxLWFjMjUtNjdiMTc2NzVmM2NiIiwidCI6ImI2MzA3MWMwLTVhZDItNGQ4OC05YjJmLWU3YjJkNjRlOTkxNiJ9&pageName=ReportSectionc623940b8771b80d3e34'
         },
         {"id": 1,
          "title": "Acompanhamentos DSLBR",
          "width": 600,
          "height": 373.5, 
          "fullScreen": true,
          "frameBorder": 0,
          "src": 'https://app.powerbi.com/view?r=eyJrIjoiYTQ4ZDUyNjUtY2U4MS00ZDNlLTljYTktNDUwMzg1MjIzMDgwIiwidCI6ImI2MzA3MWMwLTVhZDItNGQ4OC05YjJmLWU3YjJkNjRlOTkxNiJ9&pageName=ReportSectionc623940b8771b80d3e34'
         }
      ]
    }
  },
  methods: {
    async getIndicadores(){
      this.erro = false;
      this.dialog = true;
      this.dash = [];
      await this.model.getIndicadores()
      .then( (response) => {
          this.dash = response.data;
          //console.log(this.dash);
          this.dialog = false;
        }
      ).catch( (error)=> {
        this.dialog = false;
        this.erro = true;
        console.log("Erro ao atualizar indicadores",error);
      });
    },
    async changeEmpresa(valor){
      //console.log("mudou",valor)
      await this.getIndicadores();
    },
  },
  beforeDestroy() {
    this.$root.$off("changeEmpresa");
  },
  created() {
  },

  async mounted(){
    //Escutando o evento de troca de empresa
    this.eventEmpresa = (valor) => {
      this.changeEmpresa(valor);
    };
    this.$root.$on("changeEmpresa", this.eventEmpresa);

    await this.getIndicadores();
    //
  }
  


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flexcard {
 display: flex;
 flex-direction: column; 
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
